import { Box, Typography } from "@mui/material";
import { useTranslation } from "../../../language";

// Rendered inside a dialog on FirstLoginStep — the dialog supplies the title
export default function LabProcessingInfo() {
  const { t } = useTranslation();

  const sentences = t("onb_results_wait_lab_text").split(/(?<=\.)\s+/).filter(Boolean);
  const lastSentence = sentences.length > 1 ? sentences.pop() : null;
  const firstSentence = sentences.length > 1 ? sentences.shift() : null;
  const mainText = sentences.join(' ');

  return (
    <Box>
      {firstSentence && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          {firstSentence}
        </Typography>
      )}
      <Typography variant="body2" color="text.secondary">
        {mainText}
      </Typography>
      {lastSentence && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
          {lastSentence}
        </Typography>
      )}
    </Box>
  );
}
